import axiosInstance from "../config/API";
const API_ENDPOINT = "/balance_sheet.php";
// Fetch grouped balance sheet entries by date range
export const fetchGroupedBalanceSheetApi = async (
  fromDate = "",
  toDate = "",
  nameFilter = ""
) => {
  const payload = {
    action: "listBalanceSheetByDateRange",
    from_date: fromDate,
    to_date: toDate,
    name_filter: nameFilter,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("fetch grouped balance sheet :", response.data.body);
  return response.data.body;
};
// Add a new balance sheet entry
export const addBalanceSheetApi = async (balanceSheetData) => {
  console.log("balanceSheetData api", balanceSheetData);
  const payload = {
    action: "addBalanceSheet",
    entry_date: balanceSheetData.entry_date,
    amount: balanceSheetData.amount,
    description: balanceSheetData.description,
    agent_id: balanceSheetData.agent_id,
    agent_name: balanceSheetData.agent_name,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("add balance sheet :", response.data);
  return response.data.body;
};
// Update a balance sheet entry
export const updateBalanceSheetApi = async (balanceSheetData) => {
  console.log("updateBalanceSheetData api", balanceSheetData);
  const payload = {
    action: "updateBalanceSheet",
    balance_sheet_id: balanceSheetData.balance_sheet_id,
    entry_date: balanceSheetData.entry_date,
    amount: balanceSheetData.amount,
    description: balanceSheetData.description,
    agent_id: balanceSheetData.agent_id,
    agent_name: balanceSheetData.agent_name,
    type: balanceSheetData.type || "credit",
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("update balance sheet :", response.data);
  return response.data.body;
};
// Delete a balance sheet entry
export const deleteBalanceSheetApi = async (balanceSheetId) => {
  console.log("deleteBalanceSheetId api", balanceSheetId);
  const payload = {
    action: "deleteBalanceSheet",
    balance_sheet_id: balanceSheetId,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("delete balance sheet :", response.data);
  return response.data.body;
};
